export default {"src":"/_next/static/media/arrow-left.b5acac54.svg","height":26,"width":13,"blurWidth":0,"blurHeight":0};